import React, { useState } from "react";
import i18n from "i18next";
import { Grid, Typography } from "@mui/material";
import { makeValidate } from "mui-rff";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { FORM_ERROR } from "final-form";
import {
  PageBox,
  PageHeader,
  FormAlert,
  FormTextField,
  FormButton
} from "./Validate.style";

import { ValidateSchema } from "../../schema/ValidateSchema";
import { TabTitle } from "../../utils/GeneralFunctions";
import { useValidate } from "../../providers/ValidateProvider";
import { ValidateDataInterface } from "../../interfaces/ValidateDataInterface";
import { useAuth } from "../../providers/Auth";

const Validate = () => {
  const auth = useAuth();
  const validator = useValidate();
  const { t } = useTranslation();
  const [severity, setSeverity] = useState("success");
  const [submitLoading, setSubmitLoading] = React.useState(false);

  if (auth){
    auth.refreshSession();
  }
  
  const validate = makeValidate(ValidateSchema, (error) => {
    return i18n.t(error.message);
  });

  // PACTOOL - Search and Validate
  TabTitle(t("app.name") + " - " + t("validate.page.title"));

  let formData = {
    aeroplanNumber: "",
    lastName: ""
  };

  const onSubmit = async (values) => {
    setSubmitLoading(true);

    const query = {
      memberId: values.aeroplanNumber,
      lastName: values.lastName,
    } as ValidateDataInterface;

    const result: any = await validator.verifyAeroplanNumber(query);

    setSubmitLoading(false);
    if (result.status === "FAIL" || result.error) {
      setSeverity("error");
      return { [FORM_ERROR]: result.message };
    }
    if (result.status === "SUCCESS") {
      setSeverity("success");
      return { [FORM_ERROR]: "validate.block-form.error.validation.success" };
    }

    setSeverity("error");
    return { [FORM_ERROR]: "validate.block-form.error.validation.failed" };
  };

  return (
    <>
      <PageBox>
        <Grid container sx={{ pt: 0 }}>
          <Grid item xs={12} sm={6}>
            <PageHeader>{t("validate.page.title")}</PageHeader>
            <Typography
              component="p"
              variant="lead"
              sx={{ fontSize: "1.0em", marginBottom: "2rem" }}
            >
              {t("validate.page.description")}
            </Typography>
            <Form
              onSubmit={onSubmit}
              initialValues={formData}
              validate={validate}
              render={({
                submitError,
                handleSubmit,
                form,
                submitting,
                pristine
              }) => (
                <form onSubmit={handleSubmit}>

                  {submitError && (
                    <FormAlert severity={severity}>{t(submitError)}</FormAlert>
                  )}

                  <Typography component="p" variant="lead">
                    {t("validate.block-form.title")}
                  </Typography>

                  <FormTextField
                    name="aeroplanNumber"
                    variant="filled"
                    InputProps={{ disableUnderline: true }}
                    label={t("validate.block-form.field.aeroplannumber")}
                    id="aeroplanNumber"
                  />

                  <FormTextField
                    name="lastName"
                    variant="filled"
                    InputProps={{ disableUnderline: true }}
                    label={t("validate.block-form.field.lastname")}
                    id="lastName"
                  />

                  <FormButton
                    type="button"
                    onClick={form.reset}
                    disabled={submitting || pristine}
                  >
                    {t("validate.block-form.button.clear")}
                  </FormButton>

                  <FormButton 
                    type="submit"
                    loadingPosition="end"
                    loading={submitLoading}
                    endIcon={<div />} 
                    disabled={submitting}>
                    {t("validate.block-form.button.submit")}
                  </FormButton>

                </form>
              )}
            />
          </Grid>
        </Grid>
      </PageBox>
    </>
  );
};

export default Validate;
